<template>
  <main :class="['v-view-primary',
    $store.getters.getAcademyData.persona === undefined || $store.getters.getAcademyDaysLeft !== null
      ? 'v-view-primary-upgrade' : '']">
    <OrganismTheHeader/>
    <OrganismHomeLanding/>
  </main>
</template>

<script>
export default {
  name: 'HomeLanding',

  components: {
    OrganismHomeLanding: () => import('@/components/organisms/OrganismHomeLanding')
  }
}
</script>
